// extracted by css-extract-rspack-plugin
export default {"container":"WNSrA7XuXzMxgoHs","title":"SGCm8FKWykEPuBc2","ezaRestrictions":"F9JFUrGUYYYJzCS5","packRestrictions":"XkkeEqqFu8tSzBXB"};